export const SignatureCanvasResourcesEN: SignatureCanvasResourcesBSInterface = {
  clear: "Clear signature",
  save: "Save signature",
};

export interface SignatureCanvasResourcesBSInterface {
  clear: string;
  save: string;
}
